module.exports = __webpack_public_path__ + "media/images/diy/testimonial_bayyana-882d867818a15ea834f1282b312b6380.jpg";